import React from 'react';
import PaymentSteps from './PaymentSteps';
import styles from './JulyPaymentSteps.module.scss';

const title = <span className={styles.title}>簡単4ステップでお買い物</span>;

export default function JulyPaymentSteps() {
  return <PaymentSteps noSmallTitle title={title} />;
}
